import { Instagram } from 'lucide-react';
import { IMAGES, SITE } from '../data/content';
import { Reveal } from './Reveal';

// Instagram feed placeholder — to be wired to a real feed later.
const POSTS = [
  IMAGES.cantarito2, IMAGES.tacos1, IMAGES.mariachi,
  IMAGES.cantarito3, IMAGES.interior, IMAGES.tacos2,
];

export const InstagramSection = () => (
  <section data-testid="instagram-section" className="relative bg-brand-night overflow-hidden">
    <div className="pattern-dots-warm absolute inset-0 opacity-60" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-6 md:px-12 py-24 md:py-28">
      <Reveal>
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="uppercase text-sm tracking-[0.3em] font-semibold text-brand-gold mb-3">@cantaritosdallas</p>
            <h2 className="font-display font-bold text-3xl sm:text-5xl tracking-tight text-brand-cream">
              Sigue la Fiesta
            </h2>
            <div className="serape-underline mt-5" />
          </div>
          <a
            href={SITE.socials.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-2 bg-brand-gold text-brand-night px-6 py-3 text-sm uppercase tracking-widest font-semibold hover:bg-brand-citrus transition-colors w-fit"
          >
            <Instagram size={18} /> Síguenos
          </a>
        </div>
      </Reveal>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {POSTS.map((src, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <a
              href={SITE.socials.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid={`instagram-post-${i}`}
              className="group relative block aspect-square overflow-hidden border border-brand-line"
            >
              <img src={src} alt="Instagram post" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              <span className="absolute inset-0 bg-brand-night/0 group-hover:bg-brand-night/55 transition-colors flex items-center justify-center">
                <Instagram className="text-brand-cream opacity-0 group-hover:opacity-100 transition-opacity" size={26} />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
      <p className="mt-6 text-center text-xs text-brand-muted italic">Feed de Instagram en vivo próximamente — estas son publicaciones de ejemplo.</p>
    </div>
  </section>
);
